import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useSearchParams
} from 'react-router-dom'
import { TourProvider } from '@reactour/tour'
import { Admin } from 'components/Admin'
import { isEmpty, isNil } from 'lodash/fp'
import { SnackbarProvider } from 'notistack'
import { useParams } from 'react-admin'

const base = import.meta.env.BASE_URL === '/' ? '' : import.meta.env.BASE_URL

const Redirect: React.FC = () => {
  const { partner } = useParams()
  const [params] = useSearchParams()
  return isNil(params.get('cache_delete')) ? (
    <Navigate
      replace
      to={`${base}/menu/${partner as string}?cache_delete=True`}
    />
  ) : (
    <Admin />
  )
}
const RedirectLogin: React.FC = () => {
  return <Navigate replace to={`${base}/login`} />
}
const RedirectTop: React.FC = () => {
  return <Navigate replace to={`${base}/menu`} />
}

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <SnackbarProvider maxSnack={1}>
        {!isNil(process.env['TOUR']) ? (
          <TourProvider steps={[]}>
            <Routes>
              <Route path={`${base}/menu/:partner`} element={<Admin />} />
              <Route path={`${base}/*`} element={<Admin />} />
              <Route path={`${base}/`} element={<Admin />} />
            </Routes>
          </TourProvider>
        ) : (
          <Routes>
            <Route
              path={!isEmpty(base) ? `/` : '/dummy'}
              element={<RedirectTop />}
            />
            <Route
              path={!isEmpty(base) ? `/login` : '/loginDummy'}
              element={<RedirectLogin />}
            />
            <Route path={`${base}/menu/:partner`} element={<Redirect />} />
            <Route path={`${base}/menu/:partner/*`} element={<Admin />} />
            <Route path={`${base}/admin/:partner`} element={<Admin admin />} />
            <Route path={`${base}/*`} element={<Admin />} />
            <Route path={`${base}/`} element={<Admin />} />
          </Routes>
        )}
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default App
